import Vue from 'vue';
import moment from 'moment';
import { getMonthPickerDate, getYesterdayPickerDate, getWeekPickerDate } from '@/components/pages/transfersPage/components/transfersHistory/helpers/index';
const assetsList = [
    {
        key: '0',
        value: 'Все',
        mark: ''
    },
    {
        key: '1',
        value: 'USDT',
        mark: 'USDT'
    },
    {
        key: '2',
        value: 'USDC',
        mark: 'USDC'
    },
    {
        key: '3',
        value: 'BTC',
        mark: 'BTC'
    },
    {
        key: '4',
        value: 'BNB',
        mark: 'BNB'
    },
    {
        key: '5',
        value: 'ETH',
        mark: 'ETH'
    },
    {
        key: '6',
        value: 'XRP',
        mark: 'XRP'
    },
    {
        key: '7',
        value: 'FDUSD',
        mark: 'FDUSD'
    },
    {
        key: '8',
        value: 'TUSD',
        mark: 'TUSD'
    },
    {
        key: '9',
        value: 'BUSD',
        mark: 'BUSD'
    }
];
const historyTypesList = [
    {
        key: '0',
        value: 'Внутренние',
        mark: 'innerTransfers'
    },
    {
        key: '1',
        value: 'Внешние',
        mark: 'outerTransfers'
    },
    {
        key: '2',
        value: 'Между биржами',
        mark: 'betweenExchangesTransfers'
    }
];
export default Vue.extend({
    name: 'transfersHistoryAhead',
    props: {
        filters: {
            type: Object,
            required: true
        },
        historyType: {
            type: String,
            required: true
        }
    },
    data: () => ({
        isDatepickerOpen: false,
        tempDate: []
    }),
    computed: {
        computedDateView() {
            if (this.tempDate.length === 0)
                return 'Выбрать';
            if (this.tempDate.length === 1) {
                const yesterdayDate = getYesterdayPickerDate();
                if (this.tempDate[0] === yesterdayDate[0])
                    return 'За вчера';
                return moment(this.tempDate[0]).format('DD.MM.YYYY');
            }
            const weekDate = getWeekPickerDate();
            if (this.tempDate[0] === weekDate[0] && this.tempDate[1] === weekDate[1])
                return 'За неделю';
            const monthDate = getMonthPickerDate();
            if (this.tempDate[0] === monthDate[0] && this.tempDate[1] === monthDate[1])
                return 'За месяц';
            return `${moment(this.tempDate[0]).format('DD.MM.YYYY')} - ${moment(this.tempDate[1]).format('DD.MM.YYYY')}`;
        },
        selectedAsset() {
            const foundAsset = assetsList.find((item) => item.mark === this.filters.asset);
            if (foundAsset)
                return foundAsset.value;
            return '';
        },
        selectedHistory() {
            const foundArea = historyTypesList.find((item) => item.mark === this.historyType);
            if (foundArea)
                return foundArea.value;
            return '';
        },
        assets() {
            const assets = assetsList;
            return assets;
        },
        historyTypes() {
            const historyTypes = historyTypesList;
            return historyTypes;
        },
        isFiltersEmpty() {
            const filters = this.filters;
            return filters.dateTo === null && filters.dateFrom === null && filters.asset.length === 0;
        }
    },
    methods: {
        updateTempDate(newDates) {
            if (newDates.length > 1 && newDates[0] === newDates[1]) {
                this.tempDate = [];
                return;
            }
            if (newDates.length > 1 && moment(newDates[1]).isBefore(newDates[0])) {
                this.tempDate = [newDates[1], newDates[0]];
                return;
            }
            this.tempDate = newDates;
        },
        updateSelectedAsset(newAsset) {
            if (this.filters.asset !== newAsset.mark) {
                this.$emit('onAssetChange', newAsset.mark);
            }
        },
        updateSelectedHistory(newType) {
            if (this.historyType !== newType.mark) {
                this.$emit('onHistoryTypeChange', newType.mark);
            }
        },
        setYesterdayDate() {
            this.tempDate = getYesterdayPickerDate();
            this.isDatepickerOpen = false;
        },
        setWeekDate() {
            this.tempDate = getWeekPickerDate();
            this.isDatepickerOpen = false;
        },
        setMonthDate() {
            this.tempDate = getMonthPickerDate();
            this.isDatepickerOpen = false;
        }
    },
    watch: {
        isDatepickerOpen(v) {
            if (!v) {
                if (this.tempDate.length === 0) {
                    if (this.filters.dateFrom === null && this.filters.dateTo === null)
                        return;
                    this.$emit('onDateChange', {
                        dateTo: null,
                        dateFrom: null
                    });
                }
                if (this.tempDate.length === 1) {
                    const date = this.tempDate[0];
                    this.$emit('onDateChange', {
                        dateTo: date,
                        dateFrom: date
                    });
                }
                if (this.tempDate.length === 2) {
                    this.$emit('onDateChange', {
                        dateTo: this.tempDate[1],
                        dateFrom: this.tempDate[0]
                    });
                }
            }
        },
        filters: {
            handler(newFilters) {
                if (newFilters.dateTo === null && newFilters.dateFrom === null) {
                    this.tempDate = [];
                    return;
                }
                if (newFilters.dateTo === newFilters.dateFrom) {
                    this.tempDate = [newFilters.dateFrom];
                    return;
                }
                this.tempDate = [newFilters.dateFrom, newFilters.dateTo];
            },
            deep: true
        }
    }
});
